export const SITE = {
    name: "OSM Cargo Movers",
    tagline: "One Stop Movers",
    role: "Pan India Trailer Supplier",
    established: "2022",
    owner: "Anand Dubey",
    phones: [
        { display: "80978 94726", tel: "+918097894726" },
        { display: "84548 89902", tel: "+918454889902" },
    ],
    email: "osm.cargomovers@gmail.com",
    website: "www.osmcargomovers.com",
    address:
        "A-4020, Bima Complex, Steel Market Road, Kalamboli, Navi Mumbai – 410218",
    whatsappNumber: "918097894726",
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=Bima+Complex,+Steel+Market+Road,+Kalamboli,+Navi+Mumbai+410218",
};

export const waLink = (text) =>
    `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const DEFAULT_WA = waLink(
    "Hello OSM Cargo Movers, I need a trailer. Please share rates and availability."
);

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1618582948377-cd7eb0e8cb14?auto=format&fit=crop&w=1600&q=80",
    flatbed:
        "https://images.unsplash.com/photo-1734903251820-c781932299f8?auto=format&fit=crop&w=1600&q=80",
    twilight:
        "https://images.unsplash.com/photo-1775756789951-3f2ef4307258?auto=format&fit=crop&w=1600&q=80",
    fleet: "https://images.unsplash.com/photo-1766785368863-f2188a8c8b32?auto=format&fit=crop&w=1600&q=80",
    port: "https://images.unsplash.com/photo-1759272840538-ae4b07214c71?auto=format&fit=crop&w=1600&q=80",
    crane:
        "https://images.unsplash.com/photo-1700777685830-f501e67260e6?auto=format&fit=crop&w=1600&q=80",
    stacker:
        "https://images.unsplash.com/photo-1779419226072-3c21c89a8d9d?auto=format&fit=crop&w=1600&q=80",
    highway:
        "https://images.unsplash.com/photo-1618582948377-cd7eb0e8cb14?auto=format&fit=crop&w=1600&q=80",
    truckIndia:
        "https://images.unsplash.com/photo-1635774152029-17bf0a3e1cb4?auto=format&fit=crop&w=1600&q=80",
};

export const TRAILERS = [
    {
        size: "40FT",
        name: "40 Feet Trailer",
        hindi: "For containers & general freight",
        type: "Flatbed / Semilowbed",
        desc: "The workhorse of Indian highways — containers, palletised freight and building material, moved door to door.",
        cargo: [
            "Shipping containers",
            "Palletised & bagged cargo",
            "Steel bars & building material",
        ],
        testid: "trailer-card-40ft",
    },
    {
        size: "50FT",
        name: "50 Feet Trailer",
        hindi: "For long steel & machinery",
        type: "Flatbed / Trailer",
        desc: "Extra deck for long freight — steel, pipes and project machinery that standard vehicles cannot carry.",
        cargo: [
            "Long steel & pipes",
            "Project machinery",
            "Oversized structural loads",
        ],
        testid: "trailer-card-50ft",
    },
    {
        size: "60FT",
        name: "60 Feet Trailer",
        hindi: "For ODC & extra-long loads",
        type: "Lowbed / Semilowbed",
        desc: "Our longest placement — over-dimensional cargo and heavy equipment handled with route planning and care.",
        cargo: [
            "Over-dimensional cargo (ODC)",
            "Heavy machinery & equipment",
            "Extra-long consignments",
        ],
        testid: "trailer-card-60ft",
    },
];

export const HUBS = [
    { city: "Kalamboli, Navi Mumbai", hq: true },
    { city: "Mumbai / JNPT" },
    { city: "Pune" },
    { city: "Delhi NCR" },
    { city: "Gujarat — Mundra & Hazira" },
    { city: "Chennai" },
    { city: "Kolkata" },
    { city: "Hyderabad" },
    { city: "Bengaluru" },
    { city: "Nagpur" },
    { city: "Indore" },
    { city: "Lucknow" },
];
